"use client";

import { randInt } from "@/lib/utils/random";
import { Tooltip as ReactTooltip } from "react-tooltip";
import React, { ReactNode } from "react";
import "react-tooltip/dist/react-tooltip.css";

export default function Tooltip({
  content,
  children,
  position = "bottom",
  delay = 300,
}: {
  content: any;
  children: ReactNode;
  position?:
    | "top"
    | "top-start"
    | "top-end"
    | "right"
    | "right-start"
    | "right-end"
    | "bottom"
    | "bottom-start"
    | "bottom-end"
    | "left"
    | "left-start"
    | "left-end"; // default: bottom
  delay?: number; // default: 300ms
}) {
  const toolTipId = new Date().getMilliseconds() + randInt(1, 99);
  return (
    <>
      <div
        data-tooltip-id={toolTipId.toString()}
        data-tooltip-content={content}
        data-tooltip-place={position}
        data-tooltip-delay-show={delay}
      >
        {children}
      </div>
      <ReactTooltip
        style={{ zIndex: "99999 !important" }}
        className="!z-[9999]"
        id={toolTipId.toString()}
      />
    </>
  );
}
